import React, { useEffect, useState } from "react";
import { Form } from "antd";
import { useQueryState } from "nuqs";
import { useMessageApi } from "../../../provider/AntdNotification";
import { usePageDetail, usePageSave } from "../../../hooks/api/page/hooks";
import TabsContain from "../../components/reuseComp/TabsContain";
import { getSingleImageUrl } from "../../../lib/utils";
import { IPageDetailPayload } from "@src/types/api/page";
import Banner from "../../components/sections/Banner";
import LookingChangeOverview from "./lookingChangeOverview";

const LookingForChangeTabs: React.FC<{
  setBreadcrumb: React.Dispatch<React.SetStateAction<string>>;
}> = ({ setBreadcrumb }) => {
  const message = useMessageApi();
  const [tab, setTab] = useQueryState("tab");
  const activeTab = tab || "Banner";
  const [isEditing, setIsEditing] = useState(false);
  const [form] = Form.useForm();
  const [pageData, setPageData] = useState<any>(null);

  const { data } = usePageDetail("LOOKING_CHANGE");
  const { mutate: updatePage, isPending } = usePageSave({});

  useEffect(() => {
    if (data?.data) setPageData(data.data);
  }, [data]);

  const handleChangeTab = (section: string) => {
    setTab(section);
    setIsEditing(false);
    setBreadcrumb(section);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();

      const payload: IPageDetailPayload & { _id?: string } = {
        _id: pageData?._id,
        pageType: "LOOKING_CHANGE",
        lookingChange: {
          banner: {
            heading:
              values.banner?.heading ??
              pageData?.lookingChange?.banner?.heading ??
              "",
            image: getSingleImageUrl(
              values.banner?.image ?? pageData?.lookingChange?.banner?.image,
            ),
          },
          heading: values.heading ?? pageData?.lookingChange?.heading ?? "",
          subtext: values.subtext ?? pageData?.lookingChange?.subtext ?? "",
        },
      };

      updatePage(payload, {
        onSuccess: (res) => {
          message.success("Page updated successfully");
          setPageData(res.data);
          setIsEditing(false);
        },
        onError: () => {
          message.error("Failed to update page");
        },
      });
    } catch (error) {
      console.log("❌ Validation failed:", error);
    }
  };

  const sections = ["Banner", "Overview"];

  return (
    <div>
      <TabsContain
        sections={sections}
        handleChangeTab={handleChangeTab}
        activeTab={activeTab}
      />

      {activeTab === "Banner" && (
        <Banner
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleCancel={handleCancel}
          handleSave={handleSave}
          form={form}
          bannerData={pageData?.lookingChange?.banner}
          loading={isPending}
        />
      )}

      {activeTab === "Overview" && (
        <LookingChangeOverview
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleCancel={handleCancel}
          handleSave={handleSave}
          form={form}
          overviewData={pageData?.lookingChange}
          loading={isPending}
        />
      )}
    </div>
  );
};

export default LookingForChangeTabs;
